import React, { useState, useRef, useEffect } from "react";

const SelectDropdown = ({ selectedOption, setSelectedOption, error }) => {
  const dropdownRef = useRef(null);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const optionsList = ["Frame No", "Registered Phone No"];
  // const optionsList = ["Frame No"];

  const handleSelected = (option) => {
    setSelectedOption(option);
    setIsDropdownOpen(false);
  };

  // Close dropdown if click happens outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="w-2/3 relative" ref={dropdownRef}>
      <label htmlFor="dropdown" className="block text-sm font-medium mb-1">
        Select
        <span className="text-red-500">*</span>
      </label>
      <div
        className="flex justify-between items-center px-3 md:px-4 py-2 h-12 bg-[#f1f1f1] rounded-md cursor-pointer"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <span className="text-sm text-gray-600">{selectedOption}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-5 w-5 transform transition-transform ${
            isDropdownOpen ? "rotate-180" : "rotate-0"
          }`}
          viewBox="0 0 20 20"
          fill="text-gray-600"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.06 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      {isDropdownOpen && (
        <div className="absolute w-full bg-white mt-1 shadow-lg z-10">
          {optionsList.map((option, index) => (
            <div
              key={index}
              className={`px-4 py-2 text-md cursor-pointer ${
                selectedOption === option
                  ? "bg-gray-200 text-black border-l-4 border-black"
                  : "hover:bg-gray-200 text-black"
              }`}
              onClick={() => handleSelected(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectDropdown;
